<template>
  <v-container fill-height grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 sm6 md6 lg6 first-row>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Campaign Detail</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="canEdit && !campaignDetails.canBeEdited"
              @click.stop="enableEditing()"
              >Edit Campaign</v-btn
            >
            <v-btn
              class="ma-2"
              color="pink"
              v-if="campaignDetails.canBeEdited"
              @click.stop="updateCampaign(campaignDetails.data)"
              >Save Changes</v-btn
            >
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="campaignDetails.canBeEdited"
              @click.stop="cancelEditing()"
              >Cancel</v-btn
            >
          </v-toolbar>
          <v-form ref="campaignDetailsForm" style="padding-top: 12px">
            <v-form-base
              v-bind:value="campaignDetails.data"
              v-bind:schema="campaignSchema"
              :key="dataLoaded"
            />
          </v-form>
        </material-card>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Attributes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-file-input
              v-if="canEdit"
              accept=".pdf"
              label="Upload rules"
              ref="file"
              @change="fileUpload()"
              single-line
              hide-details
            ></v-file-input>
            <v-btn
              v-if="canEdit"
              @click="submitFile()"
              :disabled="!file"
              class="ml-4"
              outlined
              color="white"
              >Upload</v-btn
            >
          </v-toolbar>
          <v-container fluid class="pa-0">
            <v-row dense>
              <v-col :cols="12">
                <div
                  class="pink--text"
                  v-if="!campaignDetails.data.rules_uploaded"
                >
                  Il regolamento non è stato caricato.
                </div>
                <a
                  v-if="campaignDetails.data.rules_uploaded"
                  target="_blank"
                  :href="rulesUrl"
                  >Scarica il regolamento</a
                >
              </v-col>
              <v-col :cols="12">
                <v-form ref="campaignAttributesForm" style="padding-top: 12px">
                  <v-form-base
                    v-bind:value="campaignDetails.data"
                    v-bind:schema="campaignAttributesSchema"
                    :key="dataLoaded"
                  />
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </material-card>
        <material-card v-if="3 === 4">
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Configuration</v-toolbar-title>
          </v-toolbar>
          <v-container fluid class="pa-0">
            <v-row dense>
              <v-col :cols="12">
                <v-form ref="campaignAttributesForm" style="padding-top: 12px">
                  <v-form-base
                    v-bind:value="campaignConfiguration"
                    v-bind:schema="campaignConfigurationSchema"
                    :key="dataLoaded"
                  />
                  <v-color-picker
                    v-model="campaignConfiguration.primary_color"
                    mode="hex"
                  ></v-color-picker>
                  <v-color-picker
                    v-model="campaignConfiguration.secondary_color"
                    mode="hex"
                  ></v-color-picker>
                  <v-btn
                    @click="updateConfiguration"
                    class="ml-4"
                    color="primary"
                    >Update</v-btn
                  >
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </material-card>
      </v-flex>

      <v-flex md6 sm6 lg6 first-row>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Logo</v-toolbar-title>
            <upload-form
              v-if="canEdit"
              :uploadFieldLabel="'Select logo'"
              @file-submitted="uploadLogo"
            />
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              @click="deleteLogo"
              >Clear<v-icon right dark> mdi-delete </v-icon></v-btn
            >
          </v-toolbar>
          <v-img
            :src="'data:image/png;base64,' + campaignDetails.data.logo"
            aspect-ratio="1.7"
            contain
          ></v-img>
        </material-card>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Intervention areas</v-toolbar-title>
          </v-toolbar>
          <area-panel
            :canEdit="canEdit"
            :entityType="'campaign'"
            :entityId="$route.params.campaignId * 1"
          />
        </material-card>
      </v-flex>

      <v-flex xs12 sm6 md6 lg6 v-if="campaignDetails.data.mechanism_id != 3">
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Most voted Npos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title
              >Total votes:
              {{ campaignDetails.data.total_votes }}</v-toolbar-title
            >
          </v-toolbar>
          <bar-chart :key="dataLoaded3" :chartData="nposClassification" />
        </material-card>
      </v-flex>

      <v-flex xs12 sm6 md6 lg6>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Votes by week</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon @click="substractWeek(1)" class="mr-2"
              >mdi-chevron-left
            </v-icon>
            <span style="font-size: 14px"
              >Week: {{ currentWeek.weekNumber }}
              {{ currentWeek.weekDayRange }}</span
            >
            <v-icon @click="addWeek(1)" class="ml-2">mdi-chevron-right</v-icon>
          </v-toolbar>
          <bar-chart :key="dataLoaded2" :chartData="weeklyVotesChartData" />
        </material-card>
      </v-flex>

      <v-flex md6 sm6 lg6 v-if="campaignDetails.data.mechanism_id === 3">
        <VotesTable :campaignVotes="campaignVotes" />
      </v-flex>

      <v-flex xs12 sm6 md6 lg6>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Votes percentage</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <pie-chart
            v-if="pieChartDataset"
            :key="dataLoaded"
            :chartData="pieChartDataset"
          />
          <v-card-text v-if="!pieChartDataset"> No votes yet </v-card-text>
        </material-card>
      </v-flex>
      <v-flex xs12 sm6 md6 lg6 v-if="campaignDetails.data.mechanism_id === 3">
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Votes by option</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Option</th>
                  <th class="text-left">Votes</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in groupedVotes" :key="item.name">
                  <td>{{ item.label }}</td>
                  <td>{{ item.partial }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-card-text v-if="!groupedVotes"> No votes yet </v-card-text>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12 v-if="campaignDetails.data.mechanism_id != 3">
        <npo-table
          :campaign="this.$route.params.campaignId"
          :itemsPerPage="5"
          :newNpoEnabled="false"
          :uploadEnabled="false"
          :associateNpoVisible="requestQrcodeEnabled"
          :associateNpoEnabled="associationEnabled"
          :headers="npoTableHeaders"
          :canEdit="canEdit"
        />
      </v-flex>

      <v-flex md12 sm12 lg12>
        <merchants-table
          :merchants="merchantsTable.data"
          :rows="merchantsTable.data.length"
          :loading="merchantsTable.loading"
        ></merchants-table>
      </v-flex>

      <v-flex md12 sm12 lg12 v-if="campaignDetails.data.mechanism_id !== 4">
        <qrcode-table
          :campaignMerchants="merchantsTable.data"
          :requestQrcodesVisible="requestQrcodeEnabled"
          :canRequestQrcodes="canRequest"
          :itemsPerPage="5"
        />
      </v-flex>
      <v-flex md12 sm12 lg12 v-if="campaignDetails.data.mechanism_id === 4">
        <giftcard-table
          :campaignMerchants="merchantsTable.data"
          :requestGiftcardVisible="requestGiftcardEnabled"
          :canRequestGiftcard="canRequest"
          :itemsPerPage="5"
        />
      </v-flex>

      <v-flex
        v-if="
          loggedUser.role === '1' && campaignDetails.data.mechanism_id === 3
        "
        md12
        sm12
        lg12
      >
        <SurveyPanel
          :canEdit="canEdit"
          :entityType="'campaign'"
          :entityId="$route.params.campaignId * 1"
        />
      </v-flex>

      <v-flex
        md12
        sm12
        lg12
        v-if="
          campaignDetails.data.is_leading &&
          campaignDetails.data.mechanism_id != 3
        "
      >
        <leads-table :campaign="$route.params.campaignId"></leads-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import apiService from '@/services'
import { mapState } from 'vuex'
import VFormBase from 'vuetify-form-base'
import npoTable from '@/components/campaign_detail/ComponentNpoTable'
import leadsTable from '@/components/leads/ComponentLeadsTable'
import merchantsTable from '@/components/campaign_detail/ComponentCampaignMerchantsTable'
import qrcodeTable from '@/components/qrcodes/ComponentQrcodeTable'
import giftcardTable from '@/components/giftcard/ComponentGiftcardTable'
import { tablePaginationMixin } from '@/mixins/tablePaginationMixin'
import { statusColor } from '@/mixins/statusColor'
import AreaPanel from '@/components/common-components/ComponentAreaPanel'
import SurveyPanel from '@/components/survey-components/SurveyPanel'
import UploadForm from '@/components/npos/ComponentUpload'
import PieChart from '@/components/common-components/BasePieChart'
import BarChart from '@/components/common-components/BaseBarChart'
import VotesTable from '@/components/votes/VotesTable.vue'

// Import Javascript libraries
import moment from 'moment'

const mechanismOptions = [
  {
    label: 'Votes',
    value: 1
  },
  {
    label: 'Donations',
    value: 2
  },
  {
    label: 'Giftcard',
    value: 4
  }
]

export default {
  mixins: [tablePaginationMixin, statusColor],

  components: {
    VFormBase,
    npoTable,
    leadsTable,
    qrcodeTable,
    giftcardTable,
    merchantsTable,
    PieChart,
    BarChart,
    AreaPanel,
    UploadForm,
    SurveyPanel,
    VotesTable
  },

  watch: {
    qrcodesTableOptions: {
      handler () {
        this.getQrcodes(this.$route.params.campaignId)
      },
      deep: true
    },
    gifcardTableOptions: {
      handler () {
        this.getGiftCard(this.$route.params.campaignId)
      },
      deep: true
    }
  },
  data () {
    return {
      campaignConfiguration: {},
      campaignLogo: '',
      today: new Date(),
      file: null,
      dataLoaded: false, // Used to trigger form components re-rendering
      dataLoaded2: false, // Used to trigger form components re-rendering
      dataLoaded3: false, // Used to trigger form components re-rendering

      areaList: [],

      // TO DO bind statuses to BE resource after they get defined - Riccardo Cosentino 01052020
      campaignDetails: {
        canBeEdited: false,
        data: {}
      },

      // Campaign rules
      hasRules: false,

      groupedVotes: [],

      merchantsTable: {
        options: {},
        data: [],
        total: 0,
        loading: true
      },

      qrcodesTable: {
        options: {},
        data: [],
        total: 0,
        loading: true
      },
      giftcardTable: {
        options: {},
        data: [],
        total: 0,
        loading: true
      },
      campaignAreas: [],
      nposClassification: [],
      campaignInterventionAreas: [],
      campaignVotes: [],
      loading: true,
      primaryMerchant: {},
      legalRepresentative: [],
      primaryContact: [],
      contactsTableContent: [],
      weeklyVotesChartData: [],
      lineChartDataset: []
    }
  },

  computed: {
    rulesUrl () {
      return `${process.env.VUE_APP_BASE_URL}/campaigns/${this.$route.params.campaignId}/download/rules`
    },
    leadsTableVisible () {
      if (
        this.campaignDetails.data.hasOwnProperty('campaign_attributes') &&
        this.campaignDetails.data.campaign_attributes.isLeading === 'true'
      ) {
        return true
      }
      return false
    },
    requestQrcodeEnabled () {
      if (this.loggedUser.role === '1') {
        return true
      } else {
        return false
      }
    },
    requestGiftcardEnabled () {
      if (this.loggedUser.role === '1') {
        return true
      } else {
        return false
      }
    },
    canRequest () {
      if (this.campaignDetails.data.status !== 1) {
        return false
      }
      return true
    },

    currentWeek () {
      const currentDateWeek = {}
      currentDateWeek.today = this.today
      currentDateWeek.year = moment(currentDateWeek.today).isoWeekYear()
      currentDateWeek.weekNumber = moment(this.today).isoWeek()
      currentDateWeek.weekDayRange = this.weekDate(currentDateWeek.today)

      return currentDateWeek
    },

    pieChartDataset () {
      if (this.groupedVotes.length > 0) {
        const data = {
          labels: [],
          data: []
        }
        for (let i in this.groupedVotes) {
          data.labels.push(this.groupedVotes[i].label)
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.groupedVotes[i].total_votes =
            Math.round(this.groupedVotes[i].total_votes * 10) / 10
          data.data.push(this.groupedVotes[i].total_votes)
        }
        return data
      }
      return false
    },

    filteredSearchColumn () {
      // Table headers are also used for search porpuses
      // Filter out action header
      return this.nposTable.headers.filter((item) => item.value !== 'action')
    },

    campaignVotesCount () {
      return this.campaignVotes.length
    },

    npoTableHeaders () {
      const tableHeaders = [
        {
          text: 'Npo',
          align: 'left',
          value: 'name',
          sortable: true,
          searchable: true
        },
        {
          text: 'Intervention area',
          value: 'area',
          sortable: true,
          searchable: true
        },
        {
          text: 'Address',
          value: 'address',
          sortable: true,
          searchable: true
        },
        {
          text: 'Votes',
          value: 'votes',
          sortable: true,
          searchable: true
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
          searchable: false
        }
      ]

      return tableHeaders.filter((header) => {
        if (this.auth.user.role !== '1') {
          return header.value !== 'action'
        } else {
          return header
        }
      })
    },

    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    canEdit () {
      return this.auth.user.role === '1'
    },

    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas', 'initilized']),
    associationEnabled () {
      if (this.campaignDetails.canBeEdited === false) {
        if (
          this.campaignDetails.data.status === 1 ||
          this.campaignDetails.data.status === 2
        ) {
          return true
        } else {
          return false
        }
      }
      return false
    },

    // VformBase schema for campaign form
    campaignSchema () {
      let campaignStatuses = this.statuses.campaigns

      return {
        name: {
          type: 'text',
          label: 'Name',
          flex: 6,
          dense: true,
          readonly: this.campaignDetails.canBeEdited === false
        },
        status: {
          type: 'select',
          label: 'Status',
          items: campaignStatuses,
          itemValue: 'id',
          itemText: 'status_name',
          rules: [(v) => !!v || 'Status is required'],
          flex: { xs: 12, sm: 6 },
          dense: true,
          readonly: this.campaignDetails.canBeEdited === false
        },
        description: {
          type: 'textarea',
          label: 'Description',
          flex: 12,
          dense: true,
          counter: 1500,
          maxlength: 1500,
          max: 1500,
          readonly: this.campaignDetails.canBeEdited === false
        }
      }
    },
    campaignConfigurationSchema () {
      return {
        banner_title: {
          type: 'text',
          label: 'Banner title',
          dense: true,
          flex: 12,
          hideDetails: true
        },
        banner_link: {
          type: 'text',
          label: 'Banner link',
          dense: true,
          flex: 12,
          hideDetails: true
        },
        thankyou_message: {
          type: 'text',
          label: 'Thank you message',
          dense: true,
          flex: 12,
          hideDetails: true
        },
        vote_description: {
          type: 'text',
          label: 'Vote description',
          dense: true,
          flex: 12,
          hideDetails: true
        },
        show_npo_description: {
          type: 'checkbox',
          dense: true,
          label: 'Show npo description',
          flex: 6
        },
        show_npo_details: {
          type: 'checkbox',
          label: 'Show npo details',
          dense: true,
          flex: 6
        },
        banner: {
          type: 'textarea',
          label: 'Banner',
          flex: 12,
          dense: true
        }
      }
    },
    campaignAttributesSchema () {
      let campaignStatuses = this.statuses.campaigns
      return {
        is_budget_fixed: {
          type: 'checkbox',
          dense: true,
          label: 'Budget is fixed',
          flex: 6,
          readonly: this.campaignDetails.canBeEdited === false
        },
        is_leading: {
          type: 'checkbox',
          label: 'Is leading',
          dense: true,
          flex: 6,
          hideDetails: true,
          readonly: this.campaignDetails.canBeEdited === false
        },
        budget: {
          type: 'text',
          label: 'Budget',
          dense: true,
          flex: 12,
          readonly: this.campaignDetails.canBeEdited === false,
          hidden: this.campaignDetails.data.is_budget_fixed === false,
          hideDetails: true
        },
        date_start: {
          type: 'text',
          ext: 'date',
          label: 'Start date',
          prependIcon: 'mdi-calendar',
          color: 'primary',
          locale: 'en-US',
          dense: true,
          flex: 6,
          noTitle: true,
          disabled: this.startDateCanBeEdited(),
          readonly: this.startDateCanBeEdited(),
          rules: [
            (v) => !!v || 'Start date is required',
            (v) =>
              moment(v, 'YYYY-MM-DD').isSameOrAfter(moment(this.today)) ||
              'Start date cannot be lower than today',
            (v) =>
              moment(v, 'YYYY-MM-DD').isSameOrBefore(
                moment(this.campaignDetails.data.date_end)
              ) || 'Start date must be lower than End date'
          ]
        },
        date_end: {
          type: 'text',
          ext: 'date',
          label: 'End date',
          prependIcon: 'mdi-calendar',
          color: 'primary',
          locale: 'en-US',
          dense: true,
          flex: 6,
          noTitle: true,
          disabled: this.endDateCanBeEdited(),
          readonly: this.endDateCanBeEdited(),
          rules: [
            (v) => !!v || 'End date is required',
            (v) =>
              moment(v, 'YYYY-MM-DD').isSameOrAfter(moment(this.today)) ||
              'End date cannot be lower than today',
            (v) =>
              moment(v, 'YYYY-MM-DD').isSameOrAfter(
                moment(this.campaignDetails.data.date_start)
              ) || 'End date must be higher than Start Date'
          ]
        },
        mechanism_id: {
          type: 'select',
          label: 'Mechanism',
          items: mechanismOptions,
          itemText: 'label',
          itemValue: 'value',
          returnObject: false,
          readonly: this.campaignDetails.canBeEdited === false,
          rules: [(v) => !!v || 'Mechanism is required'],
          flex: { xs: 12, sm: 12, md: 12 }
        },
        cashback_amount: {
          type: 'text',
          label: 'Cashback amount',
          dense: true,
          flex: 6,
          readonly: this.campaignDetails.canBeEdited === false,
          hidden: this.campaignDetails.data.hideCashback
        },
        cashback_factor: {
          type: 'text',
          label: 'Cashback factor',
          dense: true,
          flex: 6,
          readonly: this.campaignDetails.canBeEdited === false,
          hidden: this.campaignDetails.data.hideCashback
        }
      }
    }
  },
  mounted () {
    this.getCampaign(this.$route.params.campaignId)
    // se la campagna è di tipo giftcard rimanda ad un altro componente
    // if (this.$route.params.campaignType === 'giftcard') {
    //   this.$router.push({
    //     name: 'giftcard-detail',
    //     params: {
    //       giftcardId: this.$route.params.campaignId
    //     }
    //   })
    // }
    this.getCampaignsVotes()
    this.getCampaignsGroupedVotes()
    this.getCampaignsVotesByWeek()
    this.getCampaignNposClassification()
  },
  methods: {
    getCampaign (campaignId) {
      this.loading = true
      apiService
        .getCampaign(campaignId)
        .then((response) => {
          const data = response.data

          data.date_start = moment(data.date_start).format('YYYY-MM-DD')
          // data.date_end = moment(data.date_end).format('DD-MM-YYYY')
          data.date_end = moment(data.date_end).format('YYYY-MM-DD')
          if (!data.cashback_factor) {
            data.hideCashback = true
          }

          // Define intervention areas
          this.campaignInterventionAreas = data.intervention_areas || []
          this.campaignDetails.data = data
          this.dataLoaded = !this.dataLoaded

          apiService.getCampaignMerchants(campaignId).then((response) => {
            this.merchantsTable.loading = false
            this.merchantsTable.data = response
          })
        })
        .catch((error) => {
          this.loading = false
          this.merchantsTable.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Errore nel caricamento dei dati'
          })
          console.log(error)
        })
    },

    updateConfiguration () {
      let data = this.campaignConfiguration
      data.primary_color = data.primary_color.hex
      data.secondary_color = data.secondary_color.hex
      const campaignId = this.$route.params.campaignId
      apiService
        .updateConfiguration(campaignId, data)
        .then((response) => {
          console.log('campaignVotes', this.campaignVotes)
          if (response == null) {
            this.campaignVotes = 0
          } else {
            this.campaignVotes = response || 0
          }
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Unable to load campaign votes'
          })
        })
    },

    deleteLogo () {
      const data = {
        id: this.$route.params.campaignId * 1,
        logo: ''
      }
      apiService
        .updateCampaign(data)
        .then((response) => {
          this.getCampaign(this.$route.params.campaignId)
        })
        .catch(() => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error during logo deletion'
          })
        })
    },

    getCampaignsVotes () {
      const filter = {}
      filter.campaign_id = this.$route.params.campaignId
      apiService
        .fetchData('votes', filter)
        .then((response) => {
          console.log('getCampaignsVotes', response)
          if (response == null) {
            this.campaignVotes = 0
          } else {
            this.campaignVotes = response || 0
          }

          const key = 'survey_answer'

          // In case os survey group votes by answer
          const answers = this.campaignVotes
            .reduce((acc, cur) => {
              acc[cur[key]] = acc[cur[key]] || []
              // if the key is new, initiate its value to an array, otherwise keep its own array value
              acc[cur[key]].push(cur)

              return acc
            }, [])
            .map((answer) => {
              return {
                number: answer.length,
                label: 'Ciao'
              }
            })

          console.log('ANSWERS', answers)
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Unable to load campaign votes'
          })
        })
    },

    attributeCanBeEdited (startDate, endDate) {
      if (
        moment(this.campaignDetails.data.date_start, 'YYYY-MM-DD').isBefore(
          moment(this.today, 'YYYY-MM-DD')
        )
      ) {
        return true
      }
      if (this.today > this.campaignDetails.data.start_date) {
        return false
      }
      if (this.campaignDetails.canBeEdited === true) {
        return false
      }
      return true
    },
    startDateCanBeEdited () {
      if (this.campaignDetails.canBeEdited === true) {
        console.log('TRUE')

        console.log('TRUEZcc', this.today)
        console.log('TRUEZcc', this.campaignDetails.data.date_start)

        if (
          moment(this.campaignDetails.data.date_start, 'YYYY-MM-DD').isBefore(
            moment(this.today, 'YYYY-MM-DD')
          )
        ) {
          return true
        }
        if (this.today > this.campaignDetails.data.date_start) {
          return false
        }
        return false
      }
      return true
    },
    endDateCanBeEdited () {
      if (this.campaignDetails.canBeEdited === true) {
        if (this.today > this.campaignDetails.data.end_date) {
          return true
        }
        return false
      }
      return true
    },
    uploadLogo (formData) {
      const npoId = this.$route.params.campaignId * 1
      apiService
        .uploadNpoLogo('campaigns', formData, npoId)
        .then((response) => {
          console.log(response)
          this.getCampaign(this.$route.params.campaignId)
        })
    },

    getCampaignNposClassification () {
      const filter = {}
      filter.campaign_id = this.$route.params.campaignId

      apiService
        .getCampaignNposClassification(filter)
        .then((response) => {
          console.log('CLASSIFICATION', response)
          let votes = []
          let labels = []
          for (const k in response) {
            if (response.hasOwnProperty(k)) {
              votes.push(response[k].total_votes)
              labels.push(response[k].npo_name)
            }
          }
          this.nposClassification.votes = votes
          this.nposClassification.labels = labels
          this.dataLoaded3 = !this.dataLoaded3
        })
        .catch((error) => {
          console.log(error)
        })
    },

    getCampaignsGroupedVotes () {
      const filter = {}
      filter.campaign_id = this.$route.params.campaignId
      apiService
        .getCampaignVotesByArea(filter)
        .then((response) => {
          this.loading = false
          if (response == null) {
            this.groupedVotes = []
          } else {
            this.groupedVotes = response
          }
          this.$forceUpdate()
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Unable to load campaign votes'
          })
        })
    },

    addWeek (offset) {
      this.today = moment(this.today).add(offset, 'w')
      this.getCampaignsVotesByWeek()
    },

    substractWeek (offset) {
      this.today = moment(this.today).subtract(offset, 'w')
      this.getCampaignsVotesByWeek()
    },

    getCampaignsVotesByWeek () {
      const filter = {}
      filter.campaign_id = this.$route.params.campaignId
      filter.week = this.currentWeek.weekNumber
      filter.year = this.currentWeek.year

      apiService
        .getCampaignWeeklyVotes(filter)
        .then((response) => {
          console.log('getCampaignWeeklyVotes', response)
          const vote_data = []
          for (let i = 0; i < 7; i++) {
            vote_data[i] = 0
            for (const k in response) {
              if (response[k].week_day === i + 1) {
                vote_data[i] = response[k].total
              }
            }
          }

          this.weeklyVotesChartData.votes = vote_data
          this.weeklyVotesChartData.labels = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
          ]

          this.lineChartDataset.data = vote_data
          this.dataLoaded2 = !this.dataLoaded2
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Unable to load campaign votes'
          })
        })
    },

    /* #####################################################
    #                Campaign details edit                 #
    ###################################################### */

    //  Enable editing of Campaign details
    enableEditing () {
      // Change control variable value
      this.campaignDetails.canBeEdited = !this.campaignDetails.canBeEdited
      // Save backup data
      this.campaignDetails.backup = this.campaignDetails.data
    },

    cancelEditing () {
      // Change control variable value
      this.campaignDetails.canBeEdited = !this.campaignDetails.canBeEdited
      // Restore backup data
      this.campaignDetails.data = this.campaignDetails.backup
      // Clear backup data
      this.campaignDetails.backup = {}
    },

    updateCampaign (data) {
      // Update Campaign based on campaign_id
      if (
        !this.$refs.campaignDetailsForm.validate() &&
        !this.$refs.campaignAttributesForm.validate()
      ) {
        this.$store.dispatch('alert/showSnackbar', {
          color: 'error',
          text: `Missing required fields in form`
        })
        return
      }
      const campaign = data

      campaign.mechanism = campaign.mechanism_id || 1

      !campaign.is_leading
        ? (campaign.is_leading = false)
        : (campaign.is_leading = true)

      !campaign.is_budget_fixed
        ? (campaign.is_budget_fixed = false)
        : (campaign.is_budget_fixed = true)

      apiService
        .updateCampaign(data)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Campaign succesfully updated'
          })
          // Close edit menu
          this.campaignDetails.canBeEdited = false
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error updating Campaign'
          })
          // Close edit menu
          this.campaignDetails.canBeEdited = false
        })
    },
    weekDate (value) {
      const entireWeek =
        moment(value).startOf('isoWeek').format('MMMM D -') +
        moment(value).startOf('isoWeek').add(6, 'days').format('D YYYY')
      return entireWeek
    },

    /* #####################################################
    #                Campaign rules upload                 #
    ###################################################### */

    fileUpload () {
      this.file = this.$refs.file.lazyValue
    },

    submitFile () {
      let formData = new FormData()
      if (this.file.name) {
        formData.append('file', this.file)
        formData.append('campaign_id', this.$route.params.campaignId)
        apiService
          .uploadCampaignRules(formData, this.$route.params.campaignId)
          .then((response) => {
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: 'Rules uploaded succesfully'
            })
            this.campaignDetails.data.rules_uploaded = true
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: 'Error during rules upload'
            })
          })
      }
    }
  }
}
</script>
